import axios from "axios";

const MAX_RETRIES = 2;
const BASE_DELAY = 1000;
const RETRYABLE_STATUS = [500, 502, 503, 504, 520, 521, 522, 523, 524];

/**
 * Global Axios retry interceptor.
 * Automatically retries requests that fail with 5xx or network errors,
 * using exponential backoff. Import this file once in index.js.
 */
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config) return Promise.reject(error);

    // Initialize retry count
    config.__retryCount = config.__retryCount || 0;

    const status = error.response?.status;
    const isRetryable = !status || RETRYABLE_STATUS.includes(status);

    if (!isRetryable || config.__retryCount >= MAX_RETRIES) {
      return Promise.reject(error);
    }

    config.__retryCount += 1;
    const delay = BASE_DELAY * Math.pow(2, config.__retryCount - 1);

    await new Promise((resolve) => setTimeout(resolve, delay));

    return axios(config);
  }
);

export default axios;
